import React, { useState } from 'react';
import CopyButton from './CopyButton';
import './PromptPlayground.css';

const PromptPlayground = ({
  title = 'Prompt Playground',
  templatePrompt,
  variables = [],
  description
}) => {
  const [values, setValues] = useState(
    variables.reduce((acc, v) => ({ ...acc, [v.name]: v.default || '' }), {})
  );
  const [generatedPrompt, setGeneratedPrompt] = useState('');

  const handleChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const generatePrompt = () => {
    let prompt = templatePrompt;
    Object.entries(values).forEach(([key, value]) => {
      prompt = prompt.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value || `[${key}]`);
    });
    setGeneratedPrompt(prompt);
  };

  const allFilled = variables.every(v => values[v.name]?.trim());

  return (
    <div className="playground-container">
      <div className="playground-header">
        <div className="playground-icon">🎮</div>
        <div>
          <h3>{title}</h3>
          {description && <p className="playground-description">{description}</p>}
        </div>
      </div>

      <div className="playground-content">
        <div className="playground-inputs">
          <h4>📝 Personnalisez votre prompt</h4>
          <div className="inputs-grid">
            {variables.map((variable) => (
              <div key={variable.name} className="input-group">
                <label htmlFor={variable.name}>
                  {variable.label}
                  {variable.required && <span className="required">*</span>}
                </label>
                {variable.type === 'textarea' ? (
                  <textarea
                    id={variable.name}
                    value={values[variable.name]}
                    onChange={(e) => handleChange(variable.name, e.target.value)}
                    placeholder={variable.placeholder}
                    rows={4}
                  />
                ) : variable.type === 'select' ? (
                  <select
                    id={variable.name}
                    value={values[variable.name]}
                    onChange={(e) => handleChange(variable.name, e.target.value)}
                  >
                    <option value="">Choisir...</option>
                    {variable.options.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    id={variable.name}
                    value={values[variable.name]}
                    onChange={(e) => handleChange(variable.name, e.target.value)}
                    placeholder={variable.placeholder}
                  />
                )}
                {variable.hint && <span className="input-hint">{variable.hint}</span>}
              </div>
            ))}
          </div>

          <button
            className="generate-btn"
            onClick={generatePrompt}
            disabled={!allFilled}
          >
            ✨ Générer le prompt
          </button>
        </div>

        <div className="playground-output">
          <h4>🚀 Votre prompt personnalisé</h4>
          {generatedPrompt ? (
            <div className="output-box">
              <pre>{generatedPrompt}</pre>
              <div className="output-actions">
                <CopyButton text={generatedPrompt} label="Copier le prompt" />
                <button
                  className="reset-btn"
                  onClick={() => setGeneratedPrompt('')}
                >
                  🔄 Réinitialiser
                </button>
              </div>
            </div>
          ) : (
            <div className="output-placeholder">
              <div className="placeholder-icon">📋</div>
              <p>Remplissez les champs ci-dessus et cliquez sur "Générer le prompt"</p>
            </div>
          )}
        </div>
      </div>

      <div className="playground-template">
        <details>
          <summary>👀 Voir le template du prompt</summary>
          <pre>{templatePrompt}</pre>
        </details>
      </div>
    </div>
  );
};

export default PromptPlayground;
